import { makeAutoObservable } from 'mobx';

// Note: Types should be updated and relocated as deemed appropriate
interface SidebarStatus {
  collapsed: boolean;
}

interface FeatureDetails {
  enabled: boolean;
  featureName: string;
  siteIds: string[];
  excludedSubscriptions: string[];
  _id: string;
}

interface Channel {
  _id: string;
  originDCId: string;
  truckType: string;
  status: string;
  updatedAt: Date;
}

class RootStore {
  sidebarStatus: SidebarStatus = JSON.parse(localStorage.getItem('sidebarStatus') as string) || {
    collapsed: false,
  };
  shouldRefreshOfferComparison = false;
  featureMap: Map<string, boolean> = new Map();
  isLoading = true;
  trucklaneChannels: Map<string, Channel> = new Map();
  invalidTrucklaneChannels: Map<string, Channel> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  setSidebar(status: SidebarStatus): void {
    localStorage.setItem('sidebarStatus', JSON.stringify(status));
    this.sidebarStatus = { ...this.sidebarStatus, ...status };
  }

  refreshOfferComp(status: boolean): void {
    this.shouldRefreshOfferComparison = status;
  }

  updateFeatures(featureArray: FeatureDetails[]): void {
    featureArray.map((f) => this.featureMap.set(f.featureName, f.enabled));
  }

  setLoading(loading: boolean): void {
    this.isLoading = loading;
  }

  setTrucklaneChannels(channels: Channel[]): void {
    channels.forEach((channel: Channel) => {
      this.trucklaneChannels.set(`${channel.truckType}-${channel.originDCId}`, channel);
    });
  }

  invalidateTrucklaneChannel(channel: Channel): void {
    this.invalidTrucklaneChannels.set(`${channel.truckType}-${channel.originDCId}`, channel);
  }

  clearValidTrucklaneChannels(): void {
    this.trucklaneChannels = new Map();
  }

  clearTrucklaneChannels(): void {
    this.trucklaneChannels = new Map();
    this.invalidTrucklaneChannels = new Map();
  }
}

export default RootStore;
